<template>
  <gmap-map class="vue-map" :center="centre" :zoom="13">
    <gmap-polyline ref="map" :path="path" :options="lineOptions"></gmap-polyline>
  </gmap-map>
</template>

<script>
import { gmapApi } from 'vue2-google-maps';
import PolylineDecoder from '@/library/PolylineDecoder';
import geometry from '@/library/Geometry';
import eventBus from '@/events/eventBus';

export default {
  name: 'map-view',
  props: {
    polyline: {
      type: [Array, String],
      required: false,
      default: null,
    },
    bounds: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data: () => ({
    centre: {
      lat: 53.0,
      lng: -1.0,
    },
    path: [],
    lineOptions: {
      strokeColor: '#FF0000',
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: '#FF0000',
      fillOpacity: 0.35,
    },
  }),
  watch: {
    polyline() {
      if (Array.isArray(this.polyine)) {
        this.path = this.polyline;
      } else {
        const d = new PolylineDecoder();
        this.path = d.decode(this.polyline);
      }
      if (this.path) {
        this.fitPath();
      }
    },
    async bounds() {
      if (this.bounds) {
        this.fitToBounds(this.bounds);
      }
    },
  },
  methods: {
    async fitPath() {
      if (this.path.length === 1) {
        this.centre = this.path[0];
      } else if (this.path.length > 1) {
        this.fitToBounds(geometry.bounds(this.path));
      }
    },
    async fitToBounds(bounds) {
      const map = await this.$refs.map.$mapPromise;
      const llBounds = new google.maps.LatLngBounds(bounds.ne, bounds.sw);
      await map.fitBounds(llBounds);
    },
  },
};
</script>

<style scoped>
.vue-map {
  width: 100%;
  height: 100%;
}
</style>
